
































import AuthModule, { AuthStatus } from '@/store/modules/auth.module';
import { Component, Vue, Watch } from 'vue-property-decorator';
import AppMenuService from '@/services/appMenu.service';
import SidebarMenuItem from '@/components/base-layout/menu/SidebarMenuItem.vue';
import TaftIconButton from '@/components/base-layout/TaftIconButton.vue';
import TaftUserName from '@/components/base-layout/TaftUserName.vue';
import { getModule } from 'vuex-module-decorators';

@Component({
  components: { SidebarMenuItem, TaftUserName, TaftIconButton },
})
export default class HeaderTop extends Vue {
  private authStore = getModule(AuthModule, this.$store);
  private appService = AppMenuService;

  get name() {
    return this.authStore.userName;
  }

  get items() {
    return this.appService.getMenuItems();
  }

  get isAuthenticated() {
    return this.authStore.status === AuthStatus.AuthenticationSucceeded;
  }

  @Watch('isAuthenticated')
  onUserChanged(newValue: boolean) {
    if (!newValue) {
      this.$router.push('/main');
    }
  }

  logout() {
    this.$router.push('/logout');
  }
}
